import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData } from '../../Api';
import {
    MobileInfoBox,
    Modal,
    PanelBox,
    TextView,
    Title
} from '../../components/Display';
import {
    Button,
    DataForm,
    MultiSelectBox,
    SearchBox,
    SearchDateBox,
} from '../../components/Form';
import {
    Grid,
    GridColumn,
    LeftComponents,
    RightComponents,
    Row,
} from '../../components/Layout';
import {
    TableBody,
    TableColumn,
    TableData,
    TableHeader,
    TableRow,
} from '../../components/Table';
import TaroffOrdersSetZone from '../orders/TaroffOrdersSetZone';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import TaroffOrdersPeikSetInit from '../peik/TaroffOrdersPeikSetInit';
import TaroffOrdersPeikSetNotAccepted from '../peik/TaroffOrdersPeikSetNotAccepted';

export default function TaroffOrdersPeikAccepted(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        console.log('data-select-');
    };
    const handlecomp4 = () => {
        console.log('handlecomp4');
    };
    const handlecomp3 = () => {
        console.log('handlecomp3');
    };
    const handlecomp2 = () => {
        const childDialog = (
            <>
                <DataForm>
                    <Title>تعیین محدوده</Title>
                    <Grid>
                        <GridColumn width={12}>
                            <TextView>سفارشات انتخاب شده به محدوده «</TextView>
                            {/* <TextView>{formViewTextTitle}</TextView> */}
                            <TextView>» منتقل شوند ؟</TextView>
                        </GridColumn>
                    </Grid>
                    <LeftComponents>
                        <Button onClick={handlecomp3}>انصراف</Button>
                        <Button onClick={handlecomp4}>ذخیره</Button>
                    </LeftComponents>
                </DataForm>
            </>
        );
        setModal(
            Modal({
                children: childDialog,
                onDismiss: () => setModal(null),
            })
        );
        console.log('child-dialog');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-accepted/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQShiftIdOptions, setFormQShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-accepted/select-data/q-shift-id').then(
            (response) => {
                setFormQShiftIdOptions(response.data);
            }
        );
    }, []);
    const [formQDeliverTimeIdOptions, setFormQDeliverTimeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-accepted/select-data/q-deliver-time-id').then(
            (response) => {
                setFormQDeliverTimeIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp5 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQIdFrom('');
        setFilterQIdTo('');
        setFilterQId('');
        setFilterQShopId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQShiftId('');
        setFilterQDeliverTimeId('');
        setFilterQCustomerName('');
        setFilterQCustomerMobile('');
        setFilterQAddress('');
        setFilterQPostCode('');
        setFilterQIdIn('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQIdFrom && (newSearchParams['q-id-from'] = filterQIdFrom);
        filterQIdTo && (newSearchParams['q-id-to'] = filterQIdTo);
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQShiftId && (newSearchParams['q-shift-id'] = filterQShiftId);
        filterQDeliverTimeId && (newSearchParams['q-deliver-time-id'] = filterQDeliverTimeId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQAddress && (newSearchParams['q-address'] = filterQAddress);
        filterQPostCode && (newSearchParams['q-post-code'] = filterQPostCode);
        filterQIdIn && (newSearchParams['q-id-in'] = filterQIdIn);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQIdFrom, setFilterQIdFrom] = useState(allProps['q-id-from'] || '');
    const [filterQIdTo, setFilterQIdTo] = useState(allProps['q-id-to'] || '');
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQShiftId, setFilterQShiftId] = useState(allProps['q-shift-id'] || '');
    const [filterQDeliverTimeId, setFilterQDeliverTimeId] = useState(
        allProps['q-deliver-time-id'] || ''
    );
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQAddress, setFilterQAddress] = useState(allProps['q-address'] || '');
    const [filterQPostCode, setFilterQPostCode] = useState(allProps['q-post-code'] || '');
    const [filterQIdIn, setFilterQIdIn] = useState(allProps['q-id-in'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-accepted/table-data', {
            size: tableSize,
            page: tablePage,
            q_id_from: filterQIdFrom,
            q_id_to: filterQIdTo,
            q_id: filterQId,
            q_shop_id: filterQShopId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_shift_id: filterQShiftId,
            q_deliver_time_id: filterQDeliverTimeId,
            q_customer_name: filterQCustomerName,
            q_customer_mobile: filterQCustomerMobile,
            q_address: filterQAddress,
            q_post_code: filterQPostCode,
            q_id_in: filterQIdIn,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp6 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersSetZone
                        taroff-orders-id={row.param_id}
                        taroff-zones-id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp7 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id_3}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp8 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetNotAccepted
                        taroff-orders-id={row.param_id_4}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp9 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetInit
                        taroff-orders-id={row.param_id_5}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>سفارشات تایید شده</Title>
                </RightComponents>
                <LeftComponents>
                    <TextView></TextView>
                    <TextView></TextView>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        انتخاب محدوده
                    </Button>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        انتقال گروهی به محدوده
                    </Button>
                </LeftComponents>
            </Row>
            <SearchBox onEnter={applyFilters}
                label={'شناسه از'}
                value={filterQIdFrom}
                onChange={setFilterQIdFrom}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'شناسه تا'}
                value={filterQIdTo}
                onChange={setFilterQIdTo}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters} label={'شناسه'} value={filterQId} onChange={setFilterQId} width={'120px'} />
            <MultiSelectBox
                label={'فروشگاه'}
                options={formQShopIdOptions}
                value={filterQShopId}
                onChange={setFilterQShopId}
            />
            <SearchBox onEnter={applyFilters}
                label={'عنوان'}
                value={filterQTitle}
                onChange={setFilterQTitle}
                width={'120px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <MultiSelectBox
                label={'شیفت های پیک تعارف'}
                options={formQShiftIdOptions}
                value={filterQShiftId}
                onChange={setFilterQShiftId}
            />
            <MultiSelectBox
                label={'زمان ارسال'}
                options={formQDeliverTimeIdOptions}
                value={filterQDeliverTimeId}
                onChange={setFilterQDeliverTimeId}
            />
            <SearchBox onEnter={applyFilters}
                label={'نام خریدار'}
                value={filterQCustomerName}
                onChange={setFilterQCustomerName}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'همراه خریدار'}
                value={filterQCustomerMobile}
                onChange={setFilterQCustomerMobile}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'آدرس'}
                value={filterQAddress}
                onChange={setFilterQAddress}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'کد پستی'}
                value={filterQPostCode}
                onChange={setFilterQPostCode}
                width={'120px'}
            />
            <Button onClick={handlecomp5} color={'secondary'}>
                جستجو
            </Button>
            <SearchBox onEnter={applyFilters}Chips label={'شناسه'} value={filterQIdIn} onChange={setFilterQIdIn} />
            <RightComponents wrap={true}>
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>مبلغ سفارش</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_shop_id_title}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_title_2}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView>{row.text_shop_code}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_customer_name}</TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView bold={true}>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_address}</TextView>
                                    <TextView>{row.text_3}</TextView>
                                    <TextView>{row.text_deliver_time_id_title}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_payable_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    {row.show && (
                                        <Button
                                            onClick={() => handlecomp6(row)}
                                            rightIcon={'far fa-check'}
                                            tooltip={'Taroff Orders Set Zone'}
                                        ></Button>
                                    )}
                                    <Button
                                        onClick={() => handlecomp7(row)}
                                        rightIcon={'far fa-info'}
                                        tooltip={'Taroff Orders View'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp8(row)}
                                        color={'accent'}
                                        rightIcon={'fal fa-ban'}
                                        tooltip={'عدم تایید'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp9(row)}
                                        rightIcon={'fal fa-undo'}
                                        tooltip={'در انتظار تایید'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
